import { render, staticRenderFns } from "./ProductFeeConfigGoogleFixedList.vue?vue&type=template&id=77d6c1e4&scoped=true"
import script from "./ProductFeeConfigGoogleFixedList.vue?vue&type=script&lang=js"
export * from "./ProductFeeConfigGoogleFixedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d6c1e4",
  null
  
)

export default component.exports